import React, { useMemo } from 'react';
import { CellRenderers } from 'utils/tableUtils';
import GenericPullConfigListing from '../GenericPullConfigListing';
import SysDigCredentialsForm from './SysDigCredentialsForm';
import SysDigMappingForm from './SysDigMappingForm';
import {isEmpty} from 'lodash';
import ContentOverlay from 'components/ContentOverlay';
import { columnRenderArrayData } from 'utils/tableUtils';

export default function SysDigConfigListing(props) {

    const columns = useMemo(()=> [
        {
            title: "Pipeline",
            dataIndex: "resultName",
            width: 240,
            render: columnRenderArrayData
        },
        {
            title: "Cluster",
            dataIndex: "imageCluster",
            width: 160,
            render: columnRenderArrayData
        },
        {
            title: "Namespace/Resource",
            dataIndex: "imageNamespace",
            width: 160,
            render: (project, record) => {
                if (isEmpty(project)) {
                    if(record.imageCluster) return 'All';
                    return CellRenderers.VALUE_OR_NA(project);
                }

                const renderName = project
                    .split(',')
                    ?.map((item) => 
                        <p>{item.split(' > ')[0]}</p>
                );
                return (
                    <ContentOverlay content={renderName} minHeight={40} />
                );
            },        
        },
        {
            title: "Image Name",
            dataIndex: "imageName",
            width: 240,
            render: (project, record) => {
                if (isEmpty(project)) {
                    if(record.imageCluster) return 'All';
                    return CellRenderers.VALUE_OR_NA(project);
                }

                const renderName = project
                    .split(',')
                    ?.map((item) => 
                        <p>{item.split(' > ')[0]}</p>
                );
                return (
                    <ContentOverlay content={renderName} minHeight={40} />
                );
            },
        }, {
            title: "Compliance",
            dataIndex: "taskName",
            width: 240,
            render: CellRenderers.VALUE_OR_NA
        }
    ],[])

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={SysDigMappingForm}
            CredentialsForm={SysDigCredentialsForm}
            extraColumns={columns}
        />
    )
}